import { MdBakeryDining } from "react-icons/md";

import BakeryToolbar from "../components/BakeryToolbar/BakeryToolbar";
import BakeryStats from "../components/BakeryStats/BakeryStats";
import BakeryGrid from "../components/BakeryGrid/BakeryGrid";

import BakeryDetailsModal from "../components/BakeryDetailsModal/BakeryDetailsModal";
import AddEditBakeryModal from "../components/AddEditBakeryModal/AddEditBakeryModal";

import DeleteModal from "../components/Shared/DeleteModal/DeleteModal";
import EmptyState from "../components/Shared/EmptyState/EmptyState";
import LoadingSpinner from "../components/Shared/LoadingSpinner/LoadingSpinner";
import useBakery from "../hooks/useBakery";
import useBakeryForm from "../hooks/useBakeryForm";

import "../styles/BakeryManagementPage.css";

function BakeryManagementPage() {

  const bakery = useBakery();

  const bakeryForm = useBakeryForm(
    bakery.selectedProduct,
    bakery.fetchProducts
  );

  if (bakery.loading) {
    return (
      <LoadingSpinner
        text="Loading Bakery Products..."
      />
    );
  }

  return (
    <div className="bakery-management-page">

      <BakeryToolbar
        search={bakery.search}
        onSearch={bakery.setSearch}
        category={bakery.category}
        onCategoryChange={bakery.setCategory}
        onAdd={() => bakery.openAddModal()}
      />

      <BakeryStats
        products={bakery.products}
      />

      {bakery.filteredProducts.length === 0 ? (

        <EmptyState
          icon={<MdBakeryDining />}
          title="No Bakery Products"
          description="Start by adding your first bakery product."
          buttonText="Add Product"
          onButtonClick={bakery.openAddModal}
        />

      ) : (

        <BakeryGrid
          products={bakery.filteredProducts}
          onView={bakery.openDetails}
          onEdit={bakery.openEditModal}
          onDelete={bakery.openDeleteModal}
        />

      )}

      <BakeryDetailsModal
        isOpen={bakery.showDetails}
        product={bakery.selectedProduct}
        onClose={bakery.closeDetails}
      />

      <AddEditBakeryModal
        isOpen={bakery.showForm}
        onClose={bakery.closeForm}
        formData={bakeryForm.formData}
        updateField={bakeryForm.updateField}
        submitForm={bakeryForm.submitForm}
        loading={bakeryForm.loading}
        editingProduct={bakery.selectedProduct}
      />

      <DeleteModal
        isOpen={bakery.showDelete}
        title="Delete Bakery Product"
        message={`Are you sure you want to delete "${bakery.selectedProduct?.productName}"?`}
        loading={bakery.deleteLoading}
        onCancel={bakery.closeDelete}
        onConfirm={bakery.deleteProduct}
      />

    </div>
  );
}

export default BakeryManagementPage;